import React from 'react'
import PropTypes from 'prop-types'
import {
  Tooltip,
  ResponsiveContainer,
  PieChart,
  Pie,
  Cell,
  Legend,
} from 'recharts'
import { CSVLink } from 'react-csv'
import { variables } from '@resurs/midas'

const RADIAN = Math.PI / 180
const CustomizedLabel = ({
  cx,
  cy,
  midAngle,
  innerRadius,
  outerRadius,
  percent,
  name,
  fill,
}) => {
  const radius = innerRadius + (outerRadius - innerRadius) * 1.15
  const x = cx + radius * Math.cos(-midAngle * RADIAN)
  const y = cy + radius * Math.sin(-midAngle * RADIAN)

  return (
    <text
      x={x}
      y={y}
      fill={fill}
      textAnchor={x > cx ? 'start' : 'end'}
      dominantBaseline="central"
    >
      {`${name}: ${(percent * 100).toFixed(0)}%`}
    </text>
  )
}

CustomizedLabel.propTypes = {
  cx: PropTypes.number.isRequired,
  cy: PropTypes.number.isRequired,
  midAngle: PropTypes.number.isRequired,
  innerRadius: PropTypes.number.isRequired,
  outerRadius: PropTypes.number.isRequired,
  percent: PropTypes.number.isRequired,
  name: PropTypes.string.isRequired,
  fill: PropTypes.string.isRequired,
}

const SimplePieChart = props => {
  const COLORS = [
    variables.coreColor,
    variables.controlColorWarning,
    variables.controlColorSuccess,
    variables.controlColorInfo,
    variables.controlColorDanger,
    variables.controlColorStyle,
    variables.controlColor,
  ]

  const presentationData = []

  Object.keys(props.data).forEach(i => {
    if (props.labels[i] !== undefined) {
      presentationData.push({
        name: props.labels[i],
        value: props.data[i].value,
      })
    } else {
      presentationData.push({
        name: props.data[i].name,
        value: props.data[i].value,
      })
    }
  })

  return (
    <div>
      <ResponsiveContainer height={500}>
        <PieChart>
          <Pie
            isAnimationActive
            data={presentationData}
            fill="rgb(0, 168, 230)"
            fillOpacity={0.6}
            label={CustomizedLabel}
            dataKey="value"
          >
            {props.data.map((entry, index) => (
              <Cell key={entry} fill={COLORS[index % COLORS.length]} />
            ))}
          </Pie>
          <Legend verticalAlign="top" height={60} />
          <Tooltip
            formatter={a =>
              `${a.toLocaleString()}${(props.unit && ` ${props.unit}`) || ''}`
            }
          />
        </PieChart>
      </ResponsiveContainer>
      <div style={{ textAlign: 'right', fontSize: '1rem' }}>
        <CSVLink
          data={presentationData}
          filename="piechart.csv"
          target="_blank"
        >
          {props.dllink}
        </CSVLink>
      </div>
    </div>
  )
}

SimplePieChart.propTypes = {
  data: PropTypes.array.isRequired,
  labels: PropTypes.array.isRequired,
  dllink: PropTypes.string,
  unit: PropTypes.string,
}
SimplePieChart.defaultProps = {
  dllink: 'Get CSV-file',
  unit: '',
}

export default SimplePieChart
